import { forwardRef, type Ref, type SVGProps } from "react";
const IconMinusFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26 18H6a2 2 0 0 1 0-4h20a2 2 0 0 1 0 4" />
  </svg>
);
const ForwardRef = forwardRef(IconMinusFilledSVG);
ForwardRef.displayName = "IconMinusFilled";
export { ForwardRef as IconMinusFilled };
